import { TEST_TYPES } from '../../constants/test';
import { utcDateString, toDateString } from '../../utils/dates';
import { reduce, isEmpty } from 'lodash';

export const deserializeTest = ({
  id,
  testType,
  deviceType,
  isCompleted,
  contactEmail,
  contactName,
  start,
  end,
  enderCertificationNumber,
  endTesterId,
  testPurpose,
  contactInfo,
  averageRadon,
  qc,
  company,
  tester,
  instrumentLocation,
  lastCalibration,
  closeHouseCondition,
  delay,
  deviceTestId,
  deviceLastCalibrationDate,
  duration,
  serialNumber,
  notes,
  hasData,
  intervalReport,
  mitigationSystemPresentEnum,
  severeWeatherConditions,
  siteTemperature,
  siteRelativeHumidity,
  miscellaneous1,
  miscellaneous2,
  miscellaneous3,
  miscellaneous4,
  tagNumber,
  permanentVents,
  photo1Base64,
  photo1Filename,
  photo2Base64,
  photo2Filename,
  isIsn,
  isnTestId,
  isnTestDisplayOid,
  isnAttachmentId,
  isnAttachmentDate,
  isnSyncStatus,
  isnSyncDate,
  isnSyncLastError,
  buyerEmail,
  inspectorEmail,
  bnspectorEmail,
  layoutTemplateId,
  canReportBeGenerated,
  istestValid,
  isBasic,
} = {}) => {
  contactInfo = contactInfo || {};
  qc = qc || {};
  tester = tester || {};
  company = company || {};
  lastCalibration = lastCalibration && utcDateString(lastCalibration);

  const address = contactInfo.address || {};

  return {
    id,
    testType,
    deviceType,
    qcTest: testType === TEST_TYPES.qc,
    isCompleted,
    contactEmail,
    contactName,
    start,
    end,
    enderCertificationNumber,
    endTesterId,
    lastCalibration,
    testPurpose,
    instrumentLocation,
    closeHouseCondition,
    delay,
    deviceTestId,
    duration,
    serialNumber,
    averageRadon,
    deviceLastCalibrationDate,
    qc,
    company,
    notes,
    hasData,
    mitigationSystemPresentEnum,
    siteTemperature,
    siteRelativeHumidity,
    severeWeatherConditions,
    intervalReport,
    miscellaneous1,
    miscellaneous2,
    miscellaneous3,
    miscellaneous4,
    tagNumber,
    permanentVents,
    photo1Base64,
    photo1Filename,
    photo2Base64,
    photo2Filename,
    testerId: tester.id,
    testerName: `${tester.firstName} ${tester.lastName}`,
    contactPhone: contactInfo.phone,
    address1: address.address1,
    address2: address.address2,
    city: address.city,
    country: address.country,
    county: address.county,
    postalCode: address.postalCode,
    state: address.state,
    isIsn,
    isnTestId,
    isnTestDisplayOid,
    isnAttachmentId,
    isnAttachmentDate,
    isnSyncStatus,
    isnSyncDate,
    isnSyncLastError,
    buyerEmail,
    inspectorEmail,
    bnspectorEmail,
    layoutTemplateId,
    canReportBeGenerated,
    istestValid,
    isBasic,
  };
};

export const serializeTest = (test = {}) => {
  let { lastCalibration } = test;

  if (lastCalibration instanceof Date) {
    lastCalibration = toDateString(lastCalibration);
  }
  return {
    ...test,
    contactInfo: {
      phone: test.contactPhone,
      address: {
        address1: test.address1,
        address2: test.address2,
        city: test.city,
        state: test.state,
        postalCode: test.postalCode,
        country: test.country,
        county: test.county,
      },
    },
    lastCalibration,
    qc: test.testType === TEST_TYPES.qc ? test.qc : null,
  };
};

export const deserializeEnum = (res) => {
  return reduce(
    res,
    function (result, item) {
      result[item] = item;
      return result;
    },
    {},
  );
};

export const deserializeTestV2 = (test = {}) => {
  const {
    id,
    testerId,
    clientName,
    startDate,
    address,
    radonAverageResult,
    clientEmail,
    status,
    qc,
    testerName,
    deviceSN,
    instrumentLocation,
    deviceLastCalibrationDate,
    layoutTemplateId,
    canReportBeGenerated,
    isTestValid,
    isBasic,
    isCompleted,
    hasData,
    deviceType
  } = test;

  return {
    id,
    testerId,
    clientName,
    startDate,
    address1: address.address1,
    address2: address.address2,
    radonAverageResult,
    clientEmail,
    status,
    qc,
    testerName,
    deviceSN,
    instrumentLocation,
    averageRadon: isEmpty(radonAverageResult) ? null : parseFloat(radonAverageResult),
    deviceLastCalibrationDate: deviceLastCalibrationDate && utcDateString(deviceLastCalibrationDate),
    layoutTemplateId,
    canReportBeGenerated,
    isTestValid,
    isBasic,
    isCompleted,
    hasData,
    deviceType
  };
};



// WEBPACK FOOTER //
// src/actions/tests/serializers.js